import { getColors } from '../../utils'

const getStyles = () => {
  return {
    commonStyle: {
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: getColors().text,
      "&:hover": {
        opacity: 0.8,
      },
    },
  }

};

export default getStyles;
